export class CouldNotRemoveUserGroup extends Error {
  constructor() {
    super('Failed to remove user group as there are no other user group administrators in the court system.')
    Object.setPrototypeOf(this, CouldNotRemoveUserGroup.prototype)
  }
}
